import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ObligationPeriodDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-obligationperiod',
  templateUrl: './obligationperiod.component.html',
  styleUrls: ['./obligationperiod.component.scss']
})
export class ObligationPeriodComponent implements OnChanges {


  obligationperiodForm: FormGroup;
  obligationperiodFormArray: FormGroup;
  control = new FormControl();
  @Input() obligationperiods: ObligationPeriodDto[];
  @Input() routeAnimationsElements: any;
  @Output() obligationperiod = new EventEmitter<ObligationPeriodDto[]>()
  @Output() deleteObligationPeriodEvent = new EventEmitter<any>()

    selectedObligationPeriod: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createObligationPeriodForm();
    }

    createObligationPeriodForm() {
      this.obligationperiodForm = this.fb.group({
        ObligationPeriodName: ['', Validators.required],
        ObligationPeriodDays: ['', Validators.required],
        id: null
        });
        this.obligationperiodFormArray = this.fb.group({ ObligationPeriods: this.fb.array([])
          });
        this.setObligationPeriod();
    }

  // method to display obligationperiods
  setObligationPeriod() {
    const control  = this.obligationperiodFormArray.controls.ObligationPeriods as FormArray;
    this.obligationperiods.forEach( e => {
      control.push(
        this.fb.group({
          ObligationPeriodName: e.ObligationPeriodName,         
          ObligationPeriodDays: e.ObligationPeriodDays,
          id: e.id
        })
      );
    });
  }


  // method to add ObligationPeriod
  addObligationPeriod(value: ObligationPeriodDto) {
    const control  = this.obligationperiodFormArray.controls.ObligationPeriods as FormArray;
    control.insert(0,
          this.fb.group({
            ObligationPeriodName: value.ObligationPeriodName,   
            ObligationPeriodDays: value.ObligationPeriodDays,
            id: null
          })
       );
  }

  selectObligationPeriod(value) {}

  // method to delete obligationperiod from arrary list
  deleteObligationPeriod(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.obligationperiodFormArray.controls.ObligationPeriods as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.obligationperiods.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.obligationperiods[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: ObligationPeriodDto) {
    if(this.obligationperiodForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.obligationperiodFormArray.get('ObligationPeriods')['controls'][this.selectedIndex].patchValue({ObligationPeriodName: formValue.ObligationPeriodName, ObligationPeriodDays: formValue.ObligationPeriodDays});
    } else {

      this.addObligationPeriod(formValue);
    }
    this.selectedIndex = null;
    this.obligationperiodForm.reset()
  }

  onEdit(index, value: ObligationPeriodDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.obligationperiodForm.patchValue({ObligationPeriodName: value.ObligationPeriodName, ObligationPeriodDays: value.ObligationPeriodDays});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.obligationperiodForm.reset();
  }

  onSubmit(formValue: ObligationPeriodDto[]) {
  this.obligationperiod.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteObligationPeriodEvent.emit(this.filteredDelete);
  }
  }

}
